export default __webpack_public_path__ + "static/media/general2024RealCase1-en-mobile.5252f42b.jpg";